var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.tableOptions)?_c('x-data-table',{attrs:{"x-options":_vm.tableOptions},scopedSlots:_vm._u([{key:"item.changedData",fn:function(ref){
var item = ref.item;
return [_c('changed-data',{attrs:{"item":item,"displayFields":_vm.displayFields,"hiddenFields":_vm.hiddenFields}})]}}],null,false,2435707533)}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }